import React from 'react';
import Utils from '../providers/Utils';

import avatar from '../Pics/avatar.jpg'
import Ws from '../providers/Ws';
import SpecificComponent from './SpecificComponent';

export default class OreLucrate extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listDaysOfWeek:
                [
                    {
                        name: 'lu',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'ma',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'mi',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'jo',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'vi',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'sa',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'rgba(202, 202, 202, 0.63)',
                        pontajList: []
                    },
                    {
                        name: 'du',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'rgba(202, 202, 202, 0.63)',
                        pontajList: []
                    }

                ],


        }
    }

    componentDidMount() {




    }


    oreColor = (o) =>{
        if(o < 8){
            return 'rgb(255, 147, 0)'
        }else if (o === 8){
            return 'rgb(33, 214, 33)'
        }else if(o > 8){
            return 'rgb(20, 149, 20)'
        }
    }

    numeLuna = (l) => {

        // console.log('l :', l);
        let rez = ''

        switch (l) {
            case 1: rez = this.dictionary.luni.ianuarie; break;
            case 2: rez = this.dictionary.luni.februarie; break;
            case 3: rez = this.dictionary.luni.martie; break;
            case 4: rez = this.dictionary.luni.aprilie; break;
            case 5: rez = this.dictionary.luni.mai; break;
            case 6: rez = this.dictionary.luni.iunie; break;
            case 7: rez = this.dictionary.luni.iulie; break;
            case 8: rez = this.dictionary.luni.august; break;
            case 9: rez = this.dictionary.luni.septembrie; break;
            case 10: rez = this.dictionary.luni.octombrie; break;
            case 11: rez = this.dictionary.luni.noiembrie; break;
            case 12: rez = this.dictionary.luni.decembrie; break;

        }

        return rez
    }


    getProgramatorInfo = () => {
        let angajati = [...this.props.angajati]
        let pontaje = [...this.props.pontajeAll]

        let u = new Utils();

        let nrOfDaysInMonth = u.getDaysInMonth(this.props.anul, this.props.luna)

        let dataSelected = new Date().setFullYear(this.props.anul)
        dataSelected = new Date(dataSelected).setMonth(this.props.luna - 1)

        // console.warn('nrOfDaysInMonth :', nrOfDaysInMonth);

        let tableHead = []

        let tH = []

        let table = []

        let tBody = []
        

        // console.log('angajati :', angajati);

        // console.log('pontaje :', pontaje);


        for (let i = -1, n = angajati.length; i < n; i++) {
            let oreTotal =0
            let tr = []
            for (let j = 0; j < nrOfDaysInMonth; j++) {
                if (i === -1) {
                    let date = new Date(dataSelected).setDate(j)
                    tH.push(<th style={{ border: '1px solid #d8d4d4', backgroundColor: this.state.listDaysOfWeek[new Date(date).getDay()].backgroundColor, color: '#72816e' }} key={`th${j}`}>{this.state.listDaysOfWeek[new Date(date).getDay()].name} </th>)

                } else {
                    let dataCalendar = u.transformDataForSql(new Date(dataSelected).setDate(j+1));

                    let filterPontaje = pontaje.filter(p => p.id_angajat === angajati[i].id)
                
                    filterPontaje = filterPontaje.filter(p => u.ParseDataFromSql(p.la_data)  === dataCalendar)

                    filterPontaje = filterPontaje.filter(p=> p.prezenta === 1 )

                    let oreLucrate = filterPontaje.reduce((a,c) => a + c.nr_ore_lucrate, 0);

                     oreTotal += oreLucrate
                    

                    

                    if (filterPontaje.length > 0) {

                        // console.log('dataCalendar :', dataCalendar);
                        // console.log('filterPontaje :', filterPontaje);
                        tr.push(<td  key={`td${angajati[i].id}${j}`} style={{ backgroundColor: this.oreColor(oreLucrate), color: 'white',verticalAlign:'unset', border: '1px solid #d8d4d4' }}><span style={{
                                                                                                                                                                                            fontSize:14,
                                                                                                                                                                                            display:'block',
                                                                                                                                                                                            textAlign:'left',
                                                                                                                                                                                            marginBottom:5
                                                                                                                                                                             }}>{j + 1}</span> <span style={{fontSize:13, color:'white', fontWeight:600}}>{oreLucrate}</span></td>)
                    } else {
                        tr.push(<td  key={`td${angajati[i].id}${j}`}  style={{ backgroundColor:(new Date(dataCalendar).getDay() ===6 || new Date(dataCalendar).getDay() === 0 ) ? 'rgba(202, 202, 202, 0.63)' : 'white', color: (new Date(dataCalendar).getDay() ===6 || new Date(dataCalendar).getDay() === 0 ) ? 'white' : 'rgba(202, 202, 202, 0.63)', textAlign:'center', border: '1px solid #d8d4d4' }}>{j + 1}</td>)
                    }
                }
                
            }

         

            tr.push(<td  key={`tdtotal`} style={{ backgroundColor: '#15b115', color: '#bdbdbd' , textAlign:'center',verticalAlign:'unset', border: '1px solid #d8d4d4' }}><span style={{
                fontSize:14,
                display:'block',
               
                marginBottom:5
 }}>Total </span> <span style={{fontSize:13, color:'white', fontWeight:600}}>{oreTotal}</span></td>)

            if (i !== -1) {
                tr = (<tr key={`tr${angajati[i].id}`}>
                    <td style={{padding:'5px 0 5px 0 '}} colSpan={3} >
                        <div style={{display:'flex', alignItems:'center'}}>

                       
                        <div
                            // onClick={()=>{this.selectFile(`file${s.id}`)}}
                            onClick={() => { this.props.openDetaliiAngajat(angajati[i]) }}
                            className='pm-angajati-picture'
                            style={{ backgroundImage: `url('${angajati[i].poza ? (new Ws().adresaMedia + '/Angajati/' + angajati[i].poza) : avatar}')` }}>

                        </div>



                        <span
                        style={{
                            textOverflow:'ellipsis',
                            overflow:'hidden',
                            width:130,
                            display:'inline-block',
                            whiteSpace:'nowrap'

                        }}
                        className='pm-title'>
                       { angajati[i].nume}
                        </span>
                        </div>
                        
                    </td>
                    {tr}
                </tr>)

                tBody.push(tr)

            }





        }

        tH.push(<th  key={`thtotal`} style={{ visibility:'hidden', backgroundColor: '#15b115', color: '#bdbdbd' , textAlign:'center',verticalAlign:'unset', border: '1px solid #d8d4d4' }}><span style={{
            fontSize:14,
            display:'block',
           
            marginBottom:5
}}>Total </span> <span style={{fontSize:13, color:'white', fontWeight:600}}></span></th>)

        



        tableHead = (<thead>
            <tr>
                <th colSpan={3}></th>
                {tH}
            </tr>
        </thead>)



        table = (
        <div className='scrolltable'>
<table  style={{ width: '95%', minWidth:1200, maxWidth:1400, margin: '20px auto', marginBottom:0, tableLayout: 'fixed', borderCollapse: 'collapse', backgroundColor: 'white', position:'relative' }}>
            {tableHead}</table>
            <div className='body'> 
                <table style={{ width: '95%', minWidth:1200,maxWidth:1400, margin: 'auto', tableLayout: 'fixed', borderCollapse: 'collapse', backgroundColor: 'white', position:'relative' }}>
                <tbody>{tBody}</tbody>
                </table>
            </div>
        </div>
        )

        return table

    }
    render() {
        return (
            <div>
                <h2 className='pm-title' >Ore Lucrate</h2>
                <div className='monthcalendar-header'>
                    <i onClick={this.props.minusLuna} className='material-icons' style={{ color: 'rgb(117, 234, 117)', verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>arrow_back</i>
                    <span style={{fontSize:20}} className='monthcalendar-title'>{this.numeLuna(this.props.luna)} - {this.props.anul}</span>
                    <i onClick={this.props.plusLuna} className='material-icons' style={{ color: 'rgb(117, 234, 117)', verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>arrow_forward</i>
                </div>

                
                        <div style={{textAlign:'center', marginTop:10}}>
                            <div style={{ display: 'inline-block' }}>
                                <div style={{ backgroundColor: 'rgb(20, 149, 20)', verticalAlign:'bottom', borderRadius:10, height:17, width:35 }} className='pm-task-legend'></div>
                                <span className='pm-title'>Peste 8 ore</span>
                            </div>
                            <div style={{ display: 'inline-block', marginLeft:10 }}>
                                <div style={{ backgroundColor: 'rgb(33, 214, 33)', verticalAlign:'bottom',borderRadius:10,height:17, width:35  }} className='pm-task-legend'></div>
                                <span className='pm-title'>8 ore</span>
                            </div>

                            <div style={{ display: 'inline-block',marginLeft:10 }}>
                                <div style={{ backgroundColor: 'rgb(255, 147, 0)', verticalAlign:'bottom',borderRadius:10 ,height:17, width:35 }} className='pm-task-legend'></div>
                                <span className='pm-title'>Mai putin de 8 ore</span>
                            </div>

                        </div>
                    

                <div style={{width:'98%', height:'90vh'}}>

                {this.getProgramatorInfo()}
                </div>
            </div>
        );
    }
}